import React, { useState } from "react";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import PlusIcon from "../../../Common/SvgIcons/CommonIcons/PlusIcon";

const TranscriptAddTag = ({ isActive, index, error, setFocus }) => {
  const [isActiveState, setIsActiveState] = useState(isActive);

  return isActiveState ? (
    <Input
      name={`TransciptTagList.${index}.section_tags`}
      placeholder="Enter Tag Name"
      error={error}
      width="16"
      height="3.5"
      gap="0"
    />
  ) : (
    <Button
      label={"Add Tag Name"}
      width="16"
      height="3.5"
      icon={PlusIcon}
      onClick={() => {
        setIsActiveState(true);
        setTimeout(() => {
          setFocus(`TransciptTagList.${index}.section_tags`);
        }, 10);
      }}
      light
      isHover
    />
  );
};

export default TranscriptAddTag;
